<template>
  <div class="page-content">
    <Loading v-if="loading" />
  </div>
</template>

<script>
import Loading from "@/components/user/layout/LoadingComponent.vue";
import { mapActions } from "vuex";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      loading: true, 
    };
  },
  async mounted() {
    await this.logoutUser();
  },
  methods: {
    ...mapActions({
      logout: "auth/logout",
    }),
    async logoutUser() {
      await this.logout();
      this.$store.commit("CLEAR_USER_DATA");
      window.location = "/login"; 
    },
  },
};
</script>
